import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {FindItemPage} from './find-item';
import {ComponentsModule} from "../../components/components.module";
import {TranslateModule} from "@ngx-translate/core";
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
   FindItemPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    ComponentsModule,
    DirectivesModule,
    InfiniteScrollModule,
    IonicPageModule.forChild(FindItemPage), ComponentsModule,
    TranslateModule.forChild(),
    PipesModule
  ],
})
export class FindItemPageModule {}



// WEBPACK FOOTER //
// ./src/pages/find-item/find-item.module.ts